const fichaAviso = {
  calculadoraSalario: {
    modal: {
      impuestos: ' a la Contribución de pensión.',
    },
  },
}

export default fichaAviso
